<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Headline</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Headline
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" @submit.prevent="simpan">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="subjek">Pesan</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="subjek" type="text" v-model="data.message"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" type="submit" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Simpan</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button v-bind:disabled="isLoading" @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine},
    name: 'Notifikasi',
    data: function () {
      return {
        data: {
          message: ''
        },
        isLoading: false
      }
    },
    mounted: function () {
      this.getData()
    },
    methods: {
      getData () {
        api.get('/hubungi-kami').then(r => {
          this.data.message = r.data.headline
        })
      },
      simpan () {
        this.isLoading = true
        var form = new FormData()
        form.append('message', this.data.message)
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/headline', form).then((result) => {
          if (result.data.code === 200) {
            this.$toastr.s('Headline berhasil dimasukan')
          } else {
            var msg = 'Headline gagal disimpan, silahkan coba kembali'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Headline.vue?04049574